import { addQuery, getQueryParams, removeQuery } from "../../Util/helper";

export class TabNavigator {
    constructor(tabs, tabContents, callback, options = { name: 'tab', forced: true, silent: false }) {
        if (!Array.isArray(tabs) || (tabContents && !Array.isArray(tabContents))) {
            console.error('Tab Navigator not setup correctly');
            return;
        }

        if (tabContents && tabContents.length != 0 && tabContents.length < tabs.length) {
            console.error('Not enough TabContents!');
            return;
        }

        this.tabs = tabs;
        this.tabContents = tabContents;
        this.currentTab = null;
        this.callback = callback;
        this.options = options;
        document.addEventListener('DOMContentLoaded', this.init.bind(this));
    }

    init() {
        if (this.tabs.length > 0 && typeof this.tabs[0] == 'string') {
            this.tabs = this.tabs.map((tab) => {
                const element = document.getElementById(tab);

                if (!element) {
                    throw new Error('Invalid Tab Id provided: ' + tab);
                }
                return element;
            });
        }

        if (this.tabContents && this.tabContents.length > 0 && typeof this.tabContents[0] == 'string') {
            this.tabContents = this.tabContents.map((content) => {
                const element = document.getElementById(content);

                if (!element) {
                    throw new Error('Invalid Tab Id provided');
                }
                return element;
            });
        }

        this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.showTab(index));
        });

        const tabId = getQueryParams().tab

        if (!tabId && tabId != "") {
            this.showTab(0, true);
        } else {
            const number = parseInt(tabId);

            if (isNaN(number) || this.tabs.length <= tabId) {
                this.showTab(0, true);
            } else {
                this.showTab(tabId, true);
            }
        }
    }

    showTab(index, first = false) {
        if (this.tabs.length <= index) {
            throw new Error('Invalid Tab index!');
        }

        this.clearAllTabs();

        this.tabs[index].classList.add('tab-active');
        if (this.tabContents && this.tabContents[index]) {
            this.tabContents[index].classList.add('active');
            this.tabContents[index].classList.remove('hidden');
        }
        this.currentTab = index;

        if (!this.options.silent) {
            if (!first || this.options.forced == undefined || this.options.forced) {
                addQuery(this.options.name || 'tab', index);
            }
        }

        if (this.callback) {
            this.callback(index);
        }
    }

    nextTab() {
        if (this.currentTab == null) {
            this.showTab(0);
            return true;
        }

        const nextIndex = this.currentTab + 1;

        if (this.tabs.length <= nextIndex) {
            return false;
        }

        this.showTab(nextIndex);
        return true;
    }

    clearAllTabs() {
        this.tabs.forEach(tab => {
            tab.classList.remove('tab-active');
        });
        if (this.tabContents) {
            this.tabContents.forEach(content => {
                content.classList.remove('active');
                content.classList.add('hidden');
            });
        }
        this.removeQuery();
    }

    removeQuery() {
        if (this.options && this.options.name != undefined && this.options.name != null) {
            removeQuery(this.options.name);
        } else {
            removeQuery('tab')
        }
    }
}